import { DropdownItemProps } from '@/lib/v2/components/Dropdown';

import {
  ActionTypeId,
  ActionTypeName,
  IOrderByCell,
  IStateOption,
} from '@/src/modules/CampaignsModule/interfaces/Campaigns';

export const STRATEGY_OTHER: DropdownItemProps = {
  id: 10,
  value: 'other',
  label: 'Other',
};

export const CAMPAIGNS_PATH = '/v2/campaigns';

export const TRANSLATE_MODAL_EDIT = 'CAMPAIGN_ACTIONS_MAIN.EDIT_ACTIONS.TOAST_MESSAGES';

export const DEFAULT_ORDERBY: IOrderByCell[] = [
  { id: 'name', isAsc: undefined },
  { id: 'lastUpdate', isAsc: true },
  { id: 'duration', isAsc: undefined },
  { id: 'audience', isAsc: undefined },
  { id: 'actions', isAsc: undefined },
];

export const DEFAULT_ORDERBY_ACTIONS: IOrderByCell[] = [
  { id: 'name', isAsc: undefined },
  { id: 'creationDate', isAsc: true },
  { id: 'exeDate', isAsc: undefined },
  { id: 'audience', isAsc: undefined },
];

export const DROPDOWN_STATE: IStateOption[] = [
  { id: 1, label: 'active', value: '1' },
  { id: 2, label: 'inactive', value: '2' },
];

export const DROPDOWN_CHANNELS: IStateOption[] = [
  { id: 1, label: 'email', value: '1' },
  { id: 2, label: 'email-trigger', value: '3' },
  { id: 3, label: 'sms', value: '8' },
  { id: 4, label: 'email-attachment', value: '9' },
  { id: 5, label: 'mail-api', value: '4' },
  { id: 6, label: 'sms-api', value: '5' },
];

export const DROPDOWN_ACTIONS_STATE: IStateOption[] = [
  { id: 1, label: 'active', value: '18' },
  { id: 2, label: 'draft', value: '1' },
  { id: 3, label: 'draft-errors', value: '22' },
  { id: 4, label: 'confirmable-draft-errors', value: '23' },
  { id: 5, label: 'confirmable-draft', value: '2' },
  { id: 6, label: 'draft-without-contacts', value: '11' },
  { id: 7, label: 'closed', value: '6' },
  { id: 8, label: 'in-progress', value: '3' },
  { id: 9, label: 'sending', value: '4' },
  { id: 10, label: 'waiting-results', value: '17' },
  { id: 11, label: 'finished', value: '5' },
  { id: 12, label: 'finished-without-contacts', value: '12' },
  { id: 13, label: 'inactive', value: '19' },
  { id: 14, label: 'incomplete-inactive', value: '20' },
  { id: 15, label: 'processing', value: '7' },
  { id: 16, label: 'processing-reinforcement', value: '9' },
  { id: 17, label: 'pending-reinforcement', value: '8' },
];

export const MASTER_ACTION = 7;

export const ACTION_TYPE_MAPPING_ROUTES: Record<ActionTypeName, ActionTypeId> = {
  email: 1,
  'email-trigger': 3,
  'mail-api': 4,
  'sms-api': 5,
  sms: 8,
  'email-attachment': 9,
};

//** cspell:disable */
export const ACTION_CREATE_MESSAGE = 'ELEMENTO_CREADO_OK';
//** cspell:enable */
